module.exports = __webpack_public_path__ + "img/45.5b52886f.jpg";